export const vertTabReady = () => {
    const tabs = document.querySelectorAll('.vert-tab-nav a');
    const mobitabs = document.querySelector('select.vert-tab-nav');

    tabs.forEach((element, ix) => {
        element.addEventListener('click', swapTabs);
    });
    if (tabs && tabs.length > 0) {
        document
            .querySelector('#' + tabs[0].dataset.tabid)
            .classList.add('opacity-100');

        mobitabs.addEventListener('change', swapTabs);
    }
};

const swapTabs = (event) => {
    let tabID;
    if (event.type === 'change') {
        tabID =
            event.currentTarget.options[event.currentTarget.selectedIndex]
                .value;
    } else {
        tabID = event.currentTarget.dataset.tabid;
    }

    const changeNav = () => {
        const activeitem = document.querySelector('.vert-tab-nav .active');
        if (activeitem) activeitem.classList.remove('active');
        if (event.target.parentElement.tagName !== 'H5')
            event.currentTarget.classList.add('active');

        changeTab();
    };

    const changeTab = () => {
        // toggle visible slide with opacity animation
        document.querySelectorAll('.tab-slide').forEach((element, ix) => {
            element.classList.remove('opacity-100');
            //element.classList.add('hidden');
        });
        document.querySelector('#' + tabID).classList.add('opacity-100');
        //document.querySelector('#' + tabID).classList.remove('hidden');
    };

    changeNav();
};
